export const sizes = {
	mobile: 959,
	desktop: 960
}

export const device = {
	mobile: `(max-width: ${sizes.mobile}px)`,
	desktop: `(min-width: ${sizes.desktop}px)`
}
